import React from "react";

export type TabsProps = {
  children: React.ReactNode;
  direction?: "vertical" | "horizontal";
  type?: "primary" | "secondary";
};

export const Tabs = ({
  children,
  direction = "horizontal",
  type = "primary"
}: TabsProps) => {
  const baseClasses = "Tabs flex flex-1 items-center";

  const directionClasses =
    direction === "vertical"
      ? "tabs-vertical flex-col flex-auto items-start h-full border-r border-panel border-border-color"
      : "tabs-horizontal w-full min-h-[62px] justify-around border-b border-border-color";

  const typeClasses = type === "secondary" ? "tabs-secondary" : "tabs-primary";

  return (
    <div className={`${baseClasses} ${directionClasses} ${typeClasses}`}>
      {children}
    </div>
  );
};
